<template>
  <div>
    <!-- <h3 class="text-center text-h5 pa-3 text-decoration-underline">
      Users Report
    </h3> -->
    <v-col cols="5" md="8" sm="6" class="mx-auto">
      <download-csv :data="this.JsonFormat" name="state.csv">
        <v-btn
          small
          rounded
          class="ml-6 btn-help-video"
          @click="checkJson"
          color="success"
        >
          CSV Export
        </v-btn>
      </download-csv>
    </v-col>
    <v-row justify="center" class="mt-2 mx-2">
      <v-data-table
        :headers="Headers"
        :items="reportData"
        :items-per-page="10"
        class="elevation-1 state-table"
        mobile-breakpoint="0"
      >
        <template v-slot:item.In_trial="{ item }">
          <p v-if="item.status == 'trialing'">Yes</p>
          <p v-else>No</p>
        </template>

        <template v-slot:item.isPaying="{ item }">
          <p v-if="item.status == 'trialing' || item.status == 'canceled'">
            No
          </p>
          <p v-else-if="item.status == 'inactive'">No</p>
          <p v-else>Yes</p>
        </template>

        <template v-slot:item.trial_date="{ item }">
          <p>{{ item.trial_date | unixTime }}</p>
        </template>

        <template v-slot:item.state="{ item }">
          <p>{{ item.state }}({{ item.ip }})</p>
        </template>

        <template v-slot:item.paying_amount="{ item }">
          <p
            v-if="item.status == 'trialing' || item.status == 'canceled'"
            class="green--text"
          >
            <b>$</b>0.00
          </p>

          <p v-else class="green--text">
            <b>$</b> {{ item.paying_amount / 100 }}
          </p>
        </template>
      </v-data-table>
    </v-row>
  </div>
</template>
<script>
import { unixTime } from "../../filters/day.js";
export default {
  name: "stateTable",
  props: {
    reportData: {
      type: [Array, Object],
      default: () => {},
    },
  },
  data() {
    return {
      JsonFormat: [],
      Headers: [
        { text: "Email", value: "email" },
        { text: "In Trial", value: "In_trial", sortable: false },
        { text: "Paying Customer", value: "isPaying", sortable: false },
        { text: "Last Payment Date", value: "trial_date" },
        { text: "Last Payment Amount", value: "paying_amount" },
        { text: "State", value: "state" },
      ],
    };
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("role") !== "client") {
      next({ name: "Pricing" });
    } else {
      next();
    }
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },

    checkJson() {
      // debugger;
      this.JsonFormat = [];
      this.JsonFormat = this.reportData.map((item) => {
        let last_payment_date = unixTime(item.trial_date);

        let newObj = {
          Email: item.email,
          Trial_Date: last_payment_date,
          In_Trial: item.status == "trialing" ? "YES" : "NO",
          Paying_Customer:
            item.status == "trialing" ||
            item.status == "canceled" ||
            item.status == "inactive"
              ? "NO"
              : "YES",
          State: item.state,
          Last_Payment_Date: last_payment_date,
          Last_Payment_Amount:
            item.status == "trialing" || item.status == "canceled"
              ? "0.00"
              : item.paying_amount / 100,
        };

        return newObj;
      });
      console.log("JsonFormat", this.JsonFormat);
      return this.JsonFormat;
    },
  },
};
</script>

<style scoped>
.state-table >>> .v-data-table-header__icon {
  opacity: 1;
}
</style>
